/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExternalMediaRequest,
  EntryType,
  FileStreamResult,
  GetMediaResponse,
  MediaGroup,
  Result,
  ResultOfCreateExternalMediaResponse,
  ResultOfUploadFileResponse,
} from '../models/index';
import {
    CreateExternalMediaRequestFromJSON,
    CreateExternalMediaRequestToJSON,
    EntryTypeFromJSON,
    EntryTypeToJSON,
    FileStreamResultFromJSON,
    FileStreamResultToJSON,
    GetMediaResponseFromJSON,
    GetMediaResponseToJSON,
    MediaGroupFromJSON,
    MediaGroupToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateExternalMediaResponseFromJSON,
    ResultOfCreateExternalMediaResponseToJSON,
    ResultOfUploadFileResponseFromJSON,
    ResultOfUploadFileResponseToJSON,
} from '../models/index';

export interface ApiMediaDownloadGetRequest {
    key?: string;
    xTenantID?: number;
}

export interface ApiMediaIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiMediaLinkExternalPostRequest {
    createExternalMediaRequest: CreateExternalMediaRequest;
    xTenantID?: number;
}

export interface ApiMediaTypeIdGetRequest {
    type: EntryType;
    id: number;
    xTenantID?: number;
}

export interface ApiMediaUploadPostRequest {
    xTenantID?: number;
    file?: Blob;
    entryId?: string;
    entryType?: EntryType;
    mediaGroup?: MediaGroup;
}

/**
 * 
 */
export class MediaApi extends runtime.BaseAPI {

    /**
     * Download a media file using its unique key.
     * Download media file
     */
    async apiMediaDownloadGetRaw(requestParameters: ApiMediaDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/media/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     * Download a media file using its unique key.
     * Download media file
     */
    async apiMediaDownloadGet(requestParameters: ApiMediaDownloadGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.apiMediaDownloadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete S3 file and metadata
     */
    async apiMediaIdDeleteRaw(requestParameters: ApiMediaIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMediaIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/media/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete S3 file and metadata
     */
    async apiMediaIdDelete(requestParameters: ApiMediaIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMediaIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Link external media like spotify, youtube etc
     */
    async apiMediaLinkExternalPostRaw(requestParameters: ApiMediaLinkExternalPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateExternalMediaResponse>> {
        if (requestParameters['createExternalMediaRequest'] == null) {
            throw new runtime.RequiredError(
                'createExternalMediaRequest',
                'Required parameter "createExternalMediaRequest" was null or undefined when calling apiMediaLinkExternalPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/media/link-external`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExternalMediaRequestToJSON(requestParameters['createExternalMediaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateExternalMediaResponseFromJSON(jsonValue));
    }

    /**
     * Link external media like spotify, youtube etc
     */
    async apiMediaLinkExternalPost(requestParameters: ApiMediaLinkExternalPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateExternalMediaResponse> {
        const response = await this.apiMediaLinkExternalPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all media links associated with a specific owner type and ID. This endpoint can be accessed anonymously, but some media may require authentication.
     * Get media by owner
     */
    async apiMediaTypeIdGetRaw(requestParameters: ApiMediaTypeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetMediaResponse>>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling apiMediaTypeIdGet().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMediaTypeIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/media/{type}/{id}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMediaResponseFromJSON));
    }

    /**
     * Get all media links associated with a specific owner type and ID. This endpoint can be accessed anonymously, but some media may require authentication.
     * Get media by owner
     */
    async apiMediaTypeIdGet(requestParameters: ApiMediaTypeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetMediaResponse>> {
        const response = await this.apiMediaTypeIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a file to S3 and save its metadata
     */
    async apiMediaUploadPostRaw(requestParameters: ApiMediaUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfUploadFileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['entryId'] != null) {
            formParams.append('EntryId', requestParameters['entryId'] as any);
        }

        if (requestParameters['entryType'] != null) {
            formParams.append('EntryType', requestParameters['entryType'] as any);
        }

        if (requestParameters['mediaGroup'] != null) {
            formParams.append('MediaGroup', requestParameters['mediaGroup'] as any);
        }


        let urlPath = `/api/media/upload`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfUploadFileResponseFromJSON(jsonValue));
    }

    /**
     * Upload a file to S3 and save its metadata
     */
    async apiMediaUploadPost(requestParameters: ApiMediaUploadPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfUploadFileResponse> {
        const response = await this.apiMediaUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
